import React, { Component } from 'react';
import { Form, Header, Segment } from 'semantic-ui-react';
import CoursesTable from '../../Exams/CoursesTable';
import { ToastContainer } from 'react-toastify';
import axios from 'axios';
import CourseExamsStatistic from './CourseExamsStatistic';
import { fetchAcademicYears } from '../../../Lookups/util';
import { fetchSemesters } from '../../StudentServiceInputGrades/InputGradesFilterStudents';
import request from '../../../util/request';
import moment from 'moment';

class ConstReports extends Component {
    constructor(props) {
        super(props);

        this.state = {
            data: [],
            excelData: [],
            report: 1,
            academicYear: null,
            semester: null,
            orgUnit: null,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],
            studyProgramBasics: [],
            studyProgramBasicId: null,

            orgUnitFilter: !!((localStorage.getItem('activeRole').substr(0, 10) !== 'Studentska' && localStorage.getItem('activeRole').substr(0, 19) !== 'Prodekan za nastavu')),


        };

        this.getAcademicYears = this.getAcademicYears.bind(this);
        this.getSemesters = this.getSemesters.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
    }
    componentDidMount() {
        let activeRole = localStorage.getItem('activeRole');
        if (localStorage.getItem('orgUnit')) {
            this.setState({ orgUnit: parseInt(localStorage.getItem('orgUnit')) });
            localStorage.setItem('activeRole', activeRole);
        }

        if (localStorage.getItem('orgUnit')) {
            let orgUnit = localStorage.getItem('orgUnit');
            window.localStorage.clear();
            localStorage.setItem('orgUnit', orgUnit);
            localStorage.setItem('activeRole', activeRole);
        }
        localStorage.setItem('activeRole', activeRole);
        this.getAcademicYears();

        let obj = {};
        axios.post((localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole') === 'Administrator' || (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
            `study-programs/basic/${localStorage.getItem('orgUnit')}`
            : 'study-programs/basic', { ...obj })
            .then(res => {
                const studyProgramBasics = res.data.map((el) => ({
                    ...el,
                    value: el.studyProgramBasic.id,
                    key: el.studyProgramBasic.id,
                    text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                    description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                })).filter(e => e.studyProgramBasic.archived === false);

                this.setState({ studyProgramBasics });
            })
            .catch(err => {
                console.log('Failed to fetch study program basics. ', err);
            });
    }

    getAcademicYears() {
        axios.get('/academic-years/current-and-previous/')
            .then(res => {
                this.setState({
                    academicYears: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })).reverse(),
                });
                // this.setState({ academicYear: this.state.academicYears[0].value });
                localStorage.setItem('academicYear', this.state.academicYear);
                axios.get(`semester/by-academic-year/${this.state.academicYear}`)
                    .then(res => {
                        this.setState({
                            semesterOptions: res.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                                ...el, key: el.id, value: el.id, text: el.name.name
                            }))
                        });
                    });
            });
    }

    getSemesters(academicYearId) {
        axios.get(`semester/by-academic-year/${academicYearId}`)
            .then(res => {
                this.setState({
                    semesterOptions: res.data.filter(e => e.name.name !== 'ostalo').map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name.name
                    }))
                });
            });
    }

    handleInputChange(event, { name, value }) {
        if (name === 'orgUnit') {
            this.setState({ semester: null });
            let obj = {};
            axios.post(`study-programs/basic/${value}`, { ...obj })
                .then(res => {
                    const studyProgramBasics = res.data.map((el) => ({
                        ...el,
                        value: el.studyProgramBasic.id,
                        key: el.studyProgramBasic.id,
                        text: el.studyProgramBasic.name + (el.studyProgramBasic.comment !== null ? ' (' + el.studyProgramBasic.comment + ')' : ''),
                        description: this.state.orgUnitFilter ? el.organizationalUnit.name : el.studyProgramBasic.studyCycles.length ? el.studyProgramBasic.studyCycles[0].displayName : ''
                    })).filter(e => e.studyProgramBasic.archived === false);

                    this.setState({ studyProgramBasics });
                })
                .catch(err => {
                    console.log('Failed to fetch study program basics. ', err);
                });
        }
        if (name === 'academicYear') { this.setState({ semester: null }); this.getSemesters(value); }
        if (name === 'semester') { localStorage.setItem('semester', value); this.getData(0); }

        if (name === 'studyProgramBasicId' && value === '') {
            this.getData(0);
        } else {
            this.getData(value);
        }
        this.setState({
            [name]: value
        });
    }

    getData(studyProgramBasicId) {
        this.setState({ loader: true });
        axios.get(this.state.orgUnitFilter ? `/exams/course-statistics-for-admin/${this.state.academicYear}/${localStorage.getItem('semester')}/${this.state.orgUnit}/${studyProgramBasicId}`
            : `/exams/course-statistics/${this.state.academicYear}/${localStorage.getItem('semester')}/${studyProgramBasicId}`)
            .then(res => {
                this.setState({
                    loader: false,
                    data: res.data.map(el => ({ ...el, averageGrade_: el.averageGrade !== null ? el.averageGrade : '' })),
                    excelData: res.data.map(el => ([
                        { value: el.courseBasicName },
                        { value: el.professor },
                        { value: el.numberOfStudentsOnCourse },
                        { value: el.numberOfDistinctStudentGradedActivities },
                        { value: el.numberOfExamRegistrations },
                        { value: el.numberOfDistinctStudentsWhoAccessedExam },
                        { value: el.numberOfStudentsWhoAccessedExam },
                        { value: el.numberOfStudentsWhoPassed },
                        { value: el.averagePassed },
                        { value: el.numberOfFs },
                        { value: el.numberOfEs },
                        { value: el.numberOfDs },
                        { value: el.numberOfCs },
                        { value: el.numberOfBs },
                        { value: el.numberOfAs },
                        { value: el.numberOfIOs },
                        { value: el.numberOfNONPs },
                        { value: el.numberOfNPs },
                        { value: el.numberOfNAs },
                        { value: el.numberOfZs },
                        { value: el.numberOfNZs },
                        { value: el.numberOfNOs },
                        { value: el.numberOfUOs },
                        { value: el.averageGrade !== null ? el.averageGrade : '' },
                    ]))
                });
                console.log('data', this.state.data);
            });
    }

    render() {
        const {
            academicYear, data, loader, semester
        } = this.state;
        return (
            <div>
                <Form>
                    <Form.Group widths="equal">
                        {this.state.orgUnitFilter && <Form.Field>
                            <Form.Dropdown
                                clearable
                                label="Organizaciona jedinica"
                                placeholder="Organizaciona jedinica"
                                value={this.state.orgUnit}
                                onChange={this.handleInputChange}
                                name="orgUnit"
                                options={this.props.organizationalUnits}
                                search
                                fluid
                                required
                                selection
                                error={this.state.organizationalUnitEntityError}
                            />
                        </Form.Field>}
                        <Form.Field>
                            <label>Akademska godina</label>
                            <Form.Dropdown
                                placeholder="Odaberite akademsku godinu"
                                value={this.state.academicYear}
                                onChange={this.handleInputChange}
                                name="academicYear"
                                options={this.state.academicYears}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <label>Semestar</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite semestar"
                                value={this.state.semester}
                                onChange={this.handleInputChange}
                                name="semester"
                                options={this.state.semesterOptions}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                        <Form.Field>
                            <Form.Dropdown
                                label="Studijski program"
                                clearable
                                placeholder="Odaberite studijski program"
                                options={this.state.studyProgramBasics}
                                onChange={this.handleInputChange}
                                name="studyProgramBasicId"
                                value={this.state.studyProgramBasicId}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                    </Form.Group>
                </Form>

                <br /><br /><br />

                {academicYear && semester && <CourseExamsStatistic data={data} loader={loader} excelData={this.state.excelData} />}

            </div>
        );
    }
}

export default ConstReports;



// WEBPACK FOOTER //
// ./src/views/StudentService/Reports/ConstReports/ConstReports.js